
import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";
import * as types from "@/state/types";
export default Vue.extend({
  computed: {},
  methods: {},
});
